import { memo } from 'react'
import { useParams } from 'react-router-dom'

import PageTabs from '@app/shared/pageTabs'

type Tab = {
  to: string
  label?: string
}

type Tabs = Record<string, Tab>

const Index = () => {
  const { '*': tab } = useParams()

  const tabs: Tabs = {}

  tabs.details = { to: 'details' }
  tabs.events = { to: 'events' }
  tabs.impact = { to: 'impact' }
  tabs.comments = { to: 'comments' }

  return <PageTabs tab={tab} tabs={tabs} />
}

export default memo(Index)
